<template>
    <div class="publication__donations content-width">
        <div class="publication__donations-row d-flex">
            <div class="publication__donations-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">
                        {{$store.getters.t('publication_project_donations_need_sum_label')}}
                    </div>
                    <div class="publication__fieldset-input">
                        <input type="number" v-model="$v.need_sum.$model" :placeholder="$store.getters.t('publication_project_donations_enter_sum')">
                    </div>
                    <div class="text-danger" v-if="!$v.need_sum.custom">{{$store.getters.t('publication_project_donations_invalid_value')}}</div>
                </div>
            </div>
            <div class="publication__donations-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">
                        {{$store.getters.t('publication_project_donations_thx_text_label')}}
                    </div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="thx_text" :placeholder="$store.getters.t('publication_project_donations_enter_text')"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.thx_text.$error">{{$store.getters.t('publication_project_donations_thx_text_invalid')}}</div>
                </div>
            </div>
        </div>

        <div class="publication__section-row d-flex">

            <div class="publication__section-inner d-flex">
                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('publication_project_donations_allow_autopay')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.allow_autopay.$model" :value="item.value">
                                <span class="circle"></span>
                                {{$store.getters.t(item.value ? 'volunteer_backend_settings_component_yes' : 'volunteer_backend_settings_component_no')}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.allow_autopay.$error">{{$store.getters.t('common_invalid_value')}}</div>

                </div>
            </div>


        </div>

    </div>
</template>

<script>

const default_temp = [ { value: 1, name: 'Yes' }, { value: 0, name: 'No' } ];

import { required, maxLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";
export default {
    name: "PublicationDonations",
    props: ['server'],
    mixins: [StateMixin],
    computed: {

        default_temp(){ return default_temp },

        allow_autopay: {
            get() { return this.GET_BY_KEY('allow_autopay') },
            set( val ) {
                this.SET_BY_KEY({key: 'allow_autopay', data:  val })
            }
        },

        need_sum: {
            get() { return this.GET_BY_KEY('need_sum') },
            set( val ) {
                this.SET_BY_KEY({key: 'need_sum', data:  val ? parseFloat(val) : null})
            }
        },

        thx_text: {
            get() { return this.GET_BY_KEY('thx_text') },
            set( val ) {
                this.SET_BY_KEY({key: 'thx_text', data: val})
            }
        },

    },



    methods: {

        isValid(){

            this.$v.$touch();
            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false

            }


            this.$emit('parent-update', true );
            return true

        }
    },

    validations:{
        need_sum: {
            required,
            custom(value){
                return parseFloat(value) >= 0
            }
        },
        allow_autopay: { required },
        thx_text:    { maxLength: maxLength(250) }
    }

}
</script>

<style scoped>

</style>
